import request from '@/utils/request'
export function pageOrderShippingList(query) {
  return request({
    url: '/shop/shop-order-shipping/detail',
    method: 'get',
    params: query
  })
}